export default __webpack_public_path__ + "static/media/vozo-logo-1.8d4192bc.png";